/* eslint-disable */
import React from 'react';
import { Snackbar, Box, Typography, IconButton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Toast — shared success/error notification
 *
 * Props:
 *   open       {boolean}
 *   message    {string}   — subtitle text
 *   title      {string}   — defaults to "Succès"
 *   severity   {string}   — "success" | "error"  (controls accent color)
 *   onClose    {Function}
 *   duration   {number}   — ms, default 4000
 */
const COLORS = {
  success: { border: '#0AD69F', icon: '#0AD69F', bg: '#FFFFFF' },
  error:   { border: '#EF456E', icon: '#EF456E', bg: '#FFFFFF' },
};

const Toast = ({ open, message, title, severity = 'success', onClose, duration = 5000 }) => {
  const c = COLORS[severity] || COLORS.success;
  const defaultTitle = severity === 'error' ? 'Erreur' : 'Succès';

  return (
    <Snackbar
      open={open}
      autoHideDuration={duration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      sx={{ top: '75px !important', right: '24px !important', left: 'auto !important', transform: 'none !important' }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          backgroundColor: c.bg,
          borderRadius: '10px',
          boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.10)',
          pl: '20px',
          pr: '16px',
          py: '14px',
          minWidth: '300px',
          maxWidth: '400px',
          minHeight: '68px',
          position: 'relative',
        }}
      >
        {/* Left accent bar */}
        <Box sx={{
          position: 'absolute', left: 0, top: '16px', bottom: '16px',
          width: '3px', borderRadius: '0 2px 2px 0',
          backgroundColor: c.border,
        }} />

        {/* Icon */}
        <Box sx={{
          width: 22, height: 22,
          borderRadius: '50%',
          border: `1.5px solid ${c.icon}`,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          flexShrink: 0,
        }}>
          <CheckIcon sx={{ color: c.icon, fontSize: 13 }} />
        </Box>

        {/* Text */}
        <Box sx={{ flex: 1 }}>
          <Typography sx={{ fontSize: '14px', fontWeight: 700, color: '#1A2035', lineHeight: 1.4 }}>
            {title || defaultTitle}
          </Typography>
          <Typography sx={{ fontSize: '13px', fontWeight: 400, color: '#385576', mt: '2px', lineHeight: 1.4 }}>
            {message}
          </Typography>
        </Box>

        {/* Close */}
        <IconButton size="small" onClick={onClose} sx={{ color: '#8397AE', p: '2px', flexShrink: 0, alignSelf: 'flex-start', '&:hover': { backgroundColor: 'transparent', color: '#385576' } }}>
          <CloseIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </Box>
    </Snackbar>
  );
};

export default Toast;